import React from "react";

import CopyToClipboard from "../../../components/CopyToClipboard/CopyToClipboard";
import formatDate from "utils/utils";
import ActiveInactiveTags from "components/Tags/ActiveInactiveTags";
import SupplierCategoryTags from "components/Tags/SupplierCategoryTags";
import { Button } from "@chakra-ui/react";

export default function GeneralTab({ supplierData }) {
  return (
    <table className="min-w-full  border primary-border-color bg-white   ">
      <tbody>
        <tr className="border-b     ">
          <td className="pl-4 py-4  h-5 w-[12rem]     ">
            <p className="table-heading  ">Name</p>
          </td>
          <td className=" table-text-light">{supplierData.supplier_name}</td>
        </tr>
        <tr className="border-b   ">
          <td className="pl-4 py-4 h-5 w-[12rem] ">
            <p className="table-heading">URL</p>
          </td>
          <td className=" table-text-light">
            <div className="w-full flex flex-row justify-between pr-6 gap-2">
              <div className="my-auto hidden md:block ">
                <a href={supplierData.supplier_url}>
                  {supplierData.supplier_url}
                </a>
              </div>
              <CopyToClipboard text={supplierData?.supplier_url} />
            </div>
          </td>
        </tr>
        <tr className="border-b   ">
          <td className="pl-4 py-4 w-[12rem]   ">
            <p className="table-heading">Category</p>
          </td>
          <td className=" table-text-light">
            <SupplierCategoryTags category_name={"Fee"} />
          </td>
        </tr>
        <tr className="border-b   ">
          <td className="pl-4 py-4 w-[12rem]   ">
            <p className="table-heading">Status</p>
          </td>
          <td className=" table-text-light">
            <ActiveInactiveTags is_active={supplierData.supplier_is_active} />
          </td>
        </tr>
        <tr className="border-b    ">
          <td className="pl-4  py-4 w-[12rem]   ">
            <p className="table-heading">Activation Date</p>
          </td>
          <td className=" py-4 table-text-light">
            {formatDate(supplierData.created_on)}
          </td>
        </tr>

        <tr className="border-b    ">
          <td className="pl-4  py-4 w-[12rem]   ">
            <p className="table-heading">Last Updated</p>
          </td>
          <td className=" py-4 table-text-light">
            {formatDate(supplierData.last_modified)}
          </td>
        </tr>
        <tr className="border-b    ">
          <td className="pl-4  py-4 w-[12rem]   ">
            <p className="table-heading">Last Checked</p>
          </td>
          <td className=" py-4 table-text-light">
            {formatDate(supplierData.last_checked)}
          </td>
        </tr>
      </tbody>
    </table>
  );
}
